import { FLOWCODE_ROOT } from '@dtx-company/true-common/src/constants/root'
import { Routes } from '@dtx-company/true-common/src/constants/routes'

const DEFAULT_TITLE = 'Flowcode: Free QR Code Generator'
const DEFAULT_DESCRIPTION =
  'Flowcode is the #1 free QR code generator. Create a custom code with colors and designs, backed with privacy and analytics. Download your code today!'
const DEFAULT_KEYWORDS =
  'qr generator, qr code, qr, free qr code, flowcode, create qr code, qr maker, qr reader, code, dtc'
const DEFAULT_URI = FLOWCODE_ROOT
const DEFAULT_IMAGE = `${FLOWCODE_ROOT}/favicon/favicon-black.png`

const FP_FAVICON: Favicon = {
  ico: '/favicon/fp-favicon.ico',
  svg: '/favicon/fp-favicon.svg',
  appleTouchIcon: '/favicon/fp-apple-touch-icon.png',
  manifest: '/favicon/fp.webmanifest'
}
const DEFAULT_KEYWORDS_FP =
  'flow, own your flow,flowcode, flowpage,connect your social media profiles,grow your followers'
const DEFAULT_URI_FP = `${process.env.PROTOCOL}://${process.env.HOST}`
const DEFAULT_IMAGE_FP = DEFAULT_URI_FP + '/static/flowpage-logo.png'
export interface Meta {
  title?: string
  description?: string
  favicon?: Favicon
  keywords?: string
  url?: string
  image?: string
  canonical?: string
}

interface Favicon {
  ico?: string
  svg?: string
  appleTouchIcon?: string
  manifest?: string
}

// add page name to override default meta attributes
export const meta: { [key: string]: Meta } = {
  default: {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    keywords: DEFAULT_KEYWORDS,
    url: DEFAULT_URI,
    favicon: {
      ico: '/favicon/favicon.ico',
      svg: '/favicon/favicon-black.svg',
      appleTouchIcon: '/favicon/apple-touch-icon.png',
      manifest: '/favicon/site.webmanifest'
    },
    image: DEFAULT_IMAGE
  },
  [Routes.INDEX]: {
    title: 'Flowcode: Free QR Code Generator',
    description:
      'Flowcode is the #1 free QR code generator. Create a custom code with colors and designs, backed with privacy and analytics. Download your code today!'
  },
  [Routes.PAGE_ANALYTICS]: {
    title: 'Flowpage | Analytics',
    description: 'Analytics',
    keywords: DEFAULT_KEYWORDS_FP,
    image: DEFAULT_IMAGE_FP,
    url: DEFAULT_URI + Routes.PAGE_ANALYTICS,
    favicon: FP_FAVICON
  },
  [Routes.SIGN_UP]: {
    title: 'Sign Up for Flowcode'
  },
  [Routes.SIGN_IN]: {
    title: 'Sign in to Flowcode'
  },
  [Routes.EDIT_CODE_DESIGN]: {
    title: 'Edit Flowcode Design',
    description: 'Edit Flowcode Design'
  },
  [Routes.EDIT_CODE]: {
    title: 'Edit Flowcode Design | Flowcode',
    description: 'Edit Flowcode Design'
  },
  [Routes.PRIVACY_POLICY]: {
    title: 'Privacy Policy'
  },
  [Routes.TAGGING]: {
    title: 'Sign up'
  },
  [Routes.TEAM]: {
    title: 'Our Team'
  },
  [Routes.DASHBOARD]: {
    title: 'Dashboard'
  },
  [Routes.STUDIO]: {
    title: 'Studio'
  },
  [Routes.CONTACT_SHARE]: {
    title: 'Flowcode | Contact Sharing'
  },
  [Routes.FLOWAPP]: {
    title: 'FLOWAPP'
  },
  [Routes.ORG]: {
    title: 'Flowcode | Organization'
  },
  [Routes.ACCEPT_INVITE]: {
    title: 'Flowcode | Accept Invite'
  },
  [Routes.REPORTS]: {
    title: 'Reports'
  },
  [Routes.REPORT]: {
    title: 'Reports | Dashboard'
  },
  [Routes.MY_ORG_MEMBERS]: {
    title: 'My Org | Members'
  },
  [Routes.MY_ORG_TEAMS]: {
    title: 'My Org | Teams'
  },
  [Routes.MY_ORG_INVITATIONS]: {
    title: 'My Org | Invitations'
  },
  [Routes.STRIPE_ONBOARDING_SUCCESS]: {
    title: 'Flowcode x Stripe'
  },
  [Routes.SALESFORCE_ONBOARDING_SUCCESS]: {
    title: 'Flowcode x Salesforce'
  },
  [Routes.PRINT_STORE_PRODUCT_TEMPLATES]: {
    title: 'Flowcode: Customizable QR Code Designs and Templates',
    description:
      'Customize your QR codes with the design and template options from Flowcode to create flyers, posters, table tents and more.'
  },
  [Routes.BRAND_KIT]: {
    title: 'Flowcode | Brand Kit'
  }
}
